import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary';
import FrontPage from './front/front-page';
import Signage from './signage/signage';
import EventSignage from './event-signage/event-signage';
import CornerSignage from './corner-signage/corner-signage';
import NextDaySignage from './next-day-signage/next-day-signage';
import {CookiesProvider} from 'react-cookie';

import './index.scss';
import NutritionCalc from './front/nutrition-calc';
import CalcHistory from './front/calc-history';
import SitePolicy from './front/site-policy';

const Fallback = ({error, resetErrorBoundary}) => {
    return (
        <div className="error-boundary-area">
            <div className="error-message-area">
                <p>
                    予期せぬエラーが発生しました。<br/>
                    お手数をお掛けいたしますが、サイネージPCの再起動を行ってください。<br/>
                    再起動を行っても同様の事象が発生する場合はシステム管理者までご連絡をお願いいたします。
                </p>
                <pre>{error.message}</pre>
            </div>
        </div>
    );
}

const FrontFallback = ({error, resetErrorBoundary}) => {
    return (
        <div className="error-boundary-area">
            <div className="error-message-area">
                <p>
                    ページが表示できません。<br/>
                    ご迷惑をお掛けいたしますが、復旧まで今しばらくお待ちください。
                </p>
            </div>
        </div>
    );
}

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path={'/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={FrontFallback}
                        >
                            <FrontPage/>
                        </ErrorBoundary>
                    }
                />
                <Route
                    path={'/nutrition-calc/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={FrontFallback}
                        >
                            <NutritionCalc/>
                        </ErrorBoundary>
                    }
                />
                <Route
                    path={'/calc-history/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={FrontFallback}
                        >
                            <CalcHistory/>
                        </ErrorBoundary>
                    }
                />
                <Route
                    path={'/site-policy/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={FrontFallback}
                        >
                            <SitePolicy/>
                        </ErrorBoundary>
                    }
                />
                <Route 
                    path={'/signage/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={Fallback}
                        >
                            <Signage/>
                        </ErrorBoundary>
                    }
                />
                <Route
                    path={'/event-signage/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={Fallback}
                        >
                            <EventSignage/>
                        </ErrorBoundary>
                    }
                />
                <Route
                    path={'/corner-signage/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={Fallback}
                        >
                            <CornerSignage/>
                        </ErrorBoundary>
                    }
                />
                <Route
                    path={'/next-day-signage/'}
                    element={
                        <ErrorBoundary
                            FallbackComponent={Fallback}
                        >
                            <NextDaySignage/>
                        </ErrorBoundary>
                    }
                />
                <Route path={'*'} element={<Navigate replace to={'/'} />} />
            </Routes>
        </BrowserRouter>
    );
};

ReactDOM.render(
    <CookiesProvider>
        <App />
    </CookiesProvider>
    , document.getElementById('primary'));
